import { useEffect } from 'react'

import { getFlow } from 'utils/FlowProvider/utils'

import trackEvent from './trackEvent'

type EventData = { [key: string]: string }

export const useTracking = (screenViewed?: EventData) => {
  const getEventProps = eventData => ({
    eventData,
    flow: getFlow(),
  })

  useEffect(() => {
    if (screenViewed) {
      trackEvent('Screen Viewed', getEventProps(screenViewed))
    }
  }, [])

  const buttonTapped = (eventData: EventData) =>
    trackEvent('Button Tapped', getEventProps(eventData))
  const containerViewed = (eventData: EventData) =>
    trackEvent('Container Viewed', getEventProps(eventData))
  const eventOccurred = (eventData: EventData) => trackEvent('Event Occurred', eventData)

  return {
    buttonTapped,
    containerViewed,
    eventOccurred,
  }
}
